import Vue from 'vue'
import './pollyfills'
import VueRouter from 'vue-router'
import VueNotify from 'vue-notifyjs'
import lang from 'element-ui/lib/locale/lang/en'
import locale from 'element-ui/lib/locale'
import App from './App.vue'

// Firebase imports
import { getAuth } from 'firebase/auth'

// Plugins
import GlobalComponents from './globalComponents'
import GlobalDirectives from './globalDirectives'
import SideBar from './components/UIComponents/SidebarPlugin'
import initProgress from './progressbar'

// router setup
import routes from './routes/routes'

// library imports
import './assets/sass/paper-dashboard.scss'
import './assets/sass/demo.scss'

import sidebarLinks from './sidebarLinks'
import './registerServiceWorker'

// plugin setup
Vue.use(VueRouter)
Vue.use(GlobalDirectives)
Vue.use(GlobalComponents)
Vue.use(VueNotify)
Vue.use(SideBar, { sidebarLinks: sidebarLinks })
locale.use(lang)

// configure router
const router = new VueRouter({
    routes, // short for routes: routes
    linkActiveClass: 'active',
    scrollBehavior: (to) => {
        if (to.hash) {
            return { selector: to.hash }
        } else {
            return { x: 0, y: 0 }
        }
    }
})

// Add the global route guard
router.beforeEach((to, from, next) => {
    const auth = getAuth(); // Get the Firebase auth instance
    const user = auth.currentUser; // Get the currently logged-in user

    if (to.meta.requiresAuth && !user) {
        // If the route requires authentication and the user is not logged in
        next('/login'); // Redirect to login page
    } else if (to.path === '/login' && user) {
        // If the user is logged in and tries to access the login page
        next('/waitlist'); // Redirect to a protected route (e.g., dashboard or waitlist)
    } else {
        next(); // Allow access to the route
    }
})

initProgress(router);

/* eslint-disable no-new */
new Vue({
    el: '#app',
    render: h => h(App),
    router
})